import * as THREE from "three";

// Sources:
// https://www.movable-type.co.uk/scripts/latlong.html
// https://stackoverflow.com/questions/7222382/get-lat-long-given-current-point-distance-and-bearing

const earthRadius = 6371000;

export interface ModelLocation {
    latitude: number,
    longitude: number
}

export function haversineDistance(src: ModelLocation, dest: ModelLocation): number {
    const dlongitude = THREE.MathUtils.degToRad(dest.longitude - src.longitude);
    const dlatitude = THREE.MathUtils.degToRad(dest.latitude - src.latitude);

    const a =
        Math.sin(dlatitude / 2) * Math.sin(dlatitude / 2) +
        Math.cos(THREE.MathUtils.degToRad(src.latitude)) *
        Math.cos(THREE.MathUtils.degToRad(dest.latitude)) *
        (Math.sin(dlongitude / 2) * Math.sin(dlongitude / 2));
    const angle = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return angle * earthRadius;
}

export function haversineDestinationFromStart(start: ModelLocation, bearing: number, distance: number): ModelLocation {
    const d = distance / earthRadius;
    const a = THREE.MathUtils.degToRad(bearing);
    const lat1 = THREE.MathUtils.degToRad(start.latitude);
    const lon1 = THREE.MathUtils.degToRad(start.longitude);
    const lat2 = Math.asin(Math.sin(lat1) * Math.cos(d) + Math.cos(lat1) * Math.sin(d) * Math.cos(a));
    const lon2 = lon1 + Math.atan2(Math.sin(a) * Math.sin(d) * Math.cos(lat1), Math.cos(d) - Math.sin(lat1) * Math.sin(lat2));
    return {
        latitude: THREE.MathUtils.radToDeg(lat2),
        longitude: THREE.MathUtils.radToDeg(lon2),
    };
}
